import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  reports: [],
  defaultReports: [],
  pagination: {},
  defaultPagination: {},
  loading: false,
  current: { template: {}, loading: false },
  downloadUrl: null,
  downloadError: false,
};

const reportsReducer = createReducer(initialState)({
  // GET REPORT LIST
  [types.FETCH_REPORTS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_REPORTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      reports: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_REPORTS_FAILED]: (state) => {
    return {
      ...state,
      reports: [],
      loading: false,
    };
  },

  // GET DEFAULT REPORT LIST
  [types.FETCH_DEFAULT_REPORTS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_DEFAULT_REPORTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      defaultReports: payload.data,
      defaultPagination: payload.pagination,
    };
  },
  [types.FETCH_DEFAULT_REPORTS_FAILED]: (state) => {
    return {
      ...state,
      defaultReports: [],
      defaultPagination: false,
    };
  },

  // GET REPORT BY ID LIST
  [types.FETCH_REPORT_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      current: {
        ...initialState.current,
        loading: true,
      },
    };
  },
  [types.FETCH_REPORT_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      current: {
        ...state.current,
        template: payload.data,
        loading: false,
      },
    };
  },
  [types.FETCH_REPORT_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      current: {
        ...state.current,
        loading: false,
      },
    };
  },

  // CREATE REPORT
  [types.CREATE_REPORT_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      current: {
        ...state.current,
        loading: true,
      },
    };
  },
  [types.CREATE_REPORT_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      current: {
        ...state.current,
        loading: false,
      },
    };
  },
  [types.CREATE_REPORT_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      current: {
        ...state.current,
        loading: false,
      },
    };
  },

  // UPDATE REPORT
  [types.UPDATE_REPORT_REQUEST]: (state) => {
    return {
      ...state,
      current: {
        ...state.current,
        loading: true,
        fetch,
      },
    };
  },
  [types.UPDATE_REPORT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      current: {
        ...state.current,
        template: { ...payload },
        loading: false,
      },
    };
  },
  [types.UPDATE_REPORT_FAILED]: (state, { payload: errors }) => {
    return {
      ...state,
      current: {
        ...state.current,
        loading: false,
        errors,
      },
    };
  },

  // DOWNLOAD REPORT
  [types.DOWNLOAD_REPORT_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.DOWNLOAD_REPORT_SUCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      downloadUrl: payload.url_signed,
    };
  },
  [types.DOWNLOAD_REPORT_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      downloadError: true,
    };
  },
});

export default reportsReducer;
